import { network } from 'services/network';

import { QueryParams, QueryResponse } from 'api/queries/getProductivityRiskTrend.query';

export const ENDPOINT = 'api/bo/getProductivityRiskTrend';

export const getProductivityRiskTrend = (params: QueryParams): Promise<QueryResponse> => {
    return network.post(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
